import { QueryConstraint, Unsubscribe } from "firebase/firestore";
import FirestorePipe from "../utils/pipe";
import EstablishmentDB from "./establishment";

class DreDB extends FirestorePipe {
    public static readonly colName = "DRE";

    constructor(idEstab: string) {
        if (!idEstab) throw new Error("Informe o id do estabelecimento");
        super(`${EstablishmentDB.colName}/${idEstab}/${DreDB.colName}`);
    }

    public async define(id: string, data: any): Promise<any> {
        return this._define(id, data);
    }

    public async create(data: any): Promise<any> {
        return this._create(data);
    }

    public async update(id: string, data: any): Promise<any> {
        return this._update(id, data);
    }

    public get(id: string): Promise<any> {
        return this._get(id);
    }

    public getAll(...params: QueryConstraint[]): Promise<any[]> {
        return this._getAll<any>(...params);
    }

    public on(listener: (data: any[]) => void, ...params: QueryConstraint[]): Unsubscribe {
        return this._on(listener, ...params);
    }

    public delete(id: string): Promise<any> {
        return this._delete(id);
    }


    public async queryByMonthYear(month: number, year: number, storeId?: string) {
        const all = await this.getAll();
        return all.filter((item) => {
            const matchMonth = item.month === month;
            const matchYear = item.year === year;
            const matchStore = storeId ? item.store === storeId : true;
            return matchMonth && matchYear && matchStore;
        });
    }


    public async saveByMonthYear(month: number, year: number, data: any, storeId?: string) {
        const existing = await this.queryByMonthYear(month, year, storeId);

        if (existing.length > 0) {
            const doc = existing[0];
            await this.update(doc.id, { ...doc, ...data });
            return doc.id;
        } else {
            const newDoc = {
                ...data,
                month,
                year,
                store: storeId || null,
                createdAt: new Date(),
            };
            const res = await this.create(newDoc);
            return res;
        }
    }
}

export default DreDB;
